import { useEffect, useState } from 'react';

/** Cuánto queda cada foto antes de empezar a cruzarse con la siguiente. */
export const SLIDE_MS = 6000;

/**
 * Índice de la foto visible en un carrusel que rota solo.
 *
 * Lo usan el costado del login y la banda lateral del alta de comercios, que muestran las
 * mismas fotos. Devuelve sólo el índice: el cruce es de la capa visual, que monta todas
 * las imágenes superpuestas y anima la opacidad.
 *
 * Con `prefers-reduced-motion` se queda en la primera y no arranca ningún temporizador.
 */
export const useSlideshow = (length: number, intervalMs = SLIDE_MS): number => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (length < 2) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

    const timer = setInterval(
      () => setIndex(current => (current + 1) % length),
      intervalMs
    );

    return () => clearInterval(timer);
  }, [length, intervalMs]);

  return index;
};
